<template lang="pug">
  l-geoJson(
    v-if="show"
    :geojson="geoJson"
    :options="options"
    :optionsStyle="styleFunction"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import { estadoRefugios, tooltipOptions } from '@/constants.js'

const buildPopup = (item, refugiosYear) => (
  `
    <h4>Albergue: ${item['nombre']}</h4>
    <div class="datos">
        ${item.estadoCenso === estadoRefugios.censado ? '<div> Censado en el año ' + refugiosYear + '</div>' : ''}
        ${item.estadoCenso === estadoRefugios.noCensado ? '<div> No censado en el año ' + refugiosYear + '</div>' : ''}
    </div>
  `
)

export default {
  data () {
    const self = this
    return {
      show: false,
      geoJson: {},
      fillColor: '#e4ce7f',
      options: {
        filter: (feature, layer) => feature.geometry,
        onEachFeature: (feature, layer) => {
          layer.bindTooltip(buildPopup(feature.properties, self.refugiosYear), { ...tooltipOptions, sticky: true })
        },
        fillColor: '#000000'
      }
    }
  },
  methods: {
    styleFunction () {
      const fillColor = '#0d2563'
      return {
        weight: 2,
        color: fillColor,
        opacity: 1,
        stroke: fillColor,
        fillColor,
        fillOpacity: 0.6
      }
    }
  },
  computed: {
    ...mapGetters({ geoJsonPromise: 'getAreaByCurrentRefugio', refugiosYear: 'refugiosYear' })
  },
  watch: {
    geoJsonPromise (promise) {
      promise.then(geoJson => { this.geoJson = geoJson })
    },
    geoJson (val) {
      this.show = !!(this.geoJson && this.geoJson.features && this.geoJson.features.length)
      this.fillColor = this.fillColor === '#878787' ? '#e4ce7f' : '#878787'
    }
  }
}
</script>
